import { useSelector } from 'react-redux';

import { getCurrentLocationSelector } from 'bento-ordering/locations/selectors';
import { CA_HONEST_PRICING_LAW } from 'constants/featureFlags';
import { CALIFORNIA, CA } from 'constants/states';

function useIsCaliforniaLocationWithServiceFee() {
  const account = useSelector(state => state.account);
  const selectedLocation = useSelector(getCurrentLocationSelector);

  return (
    account?.beta_feature_flags?.includes(CA_HONEST_PRICING_LAW) &&
    (selectedLocation?.location?.state.toUpperCase() === CALIFORNIA ||
      selectedLocation?.location?.state.toUpperCase() === CA) &&
    (selectedLocation?.charge_service_fee ||
      selectedLocation?.charge_custom_fee)
  );
}

export default useIsCaliforniaLocationWithServiceFee;
